import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import Button from '../../../../components/Buttons/Button'
import { useResponsiveness } from '../../../../hooks/responsive'
import { useTenantConfigs } from '../../../../hooks/useTenantConfigs'
import { SubStatusTitle } from '../../../../models/substatus'
import { CountryId } from '../../../../models/country-id'
import { hasRole } from '../../../../helpers/hasRole'
import { useStyles } from './BiometryResend.styles'

const BiometryResendButton = ({ subStatus, classNameBtn, onShowForm }) => {
  const isPendingBiometrics = subStatus === SubStatusTitle.PENDING_BIOMETRICS

  const { isDesktop } = useResponsiveness()
  const { configs } = useTenantConfigs()
  const classes = useStyles()

  const { user: { data } } = useSelector(({ user }) => user)

  const country = localStorage.getItem('country')?.toLowerCase()
  const isBrazil = country === CountryId.BRAZIL.toLowerCase()

  const functionIdGN = configs?.roles?.gn?.functionId
  const roleIdGN = configs?.roles?.gn?.roleId
  const functionIdLeader = configs?.roles?.leader?.functionId
  const roleIdLeader = configs?.roles?.leader?.roleId

  const isGN = hasRole({
    roles: data?.roles || [],
    functionId: functionIdGN,
    roleId: roleIdGN,
  })

  const isLeader = hasRole({
    roles: data?.roles || [],
    functionId: functionIdLeader,
    roleId: roleIdLeader,
  })

  const isGNOrLeader = isGN || isLeader

  const shouldShowButton = isPendingBiometrics && isBrazil && isGNOrLeader

  return (
    shouldShowButton && (
      <div className={classes.anchor}>
        <Button
          id="biometry-resend-button"
          variant="contained"
          color="primary"
          onClick={onShowForm}
          aria-label="biometry resend link button"
          className={isDesktop ? classes.biometryButton : classNameBtn}
          size="medium"
          type="button"
        >
          <FormattedMessage id="biometryResendButtonText" defaultMessage="REENVIAR BIOMETRIA" />
        </Button>
      </div>
    )
  )
}

export default BiometryResendButton
